import _classCallCheck from "/src/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/src/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * Copyright 2017 Atelier Disko. All rights reserved. This source
 * code is distributed under the terms of the BSD 3-Clause License.
 */
// Client for accessing the DSK APIv2.
var Client =
/*#__PURE__*/
function () {
  function Client() {
    _classCallCheck(this, Client);
  }

  _createClass(Client, null, [{
    key: "hello",
    value: function hello() {
      return this.fetch('/api/v2/hello');
    }
  }, {
    key: "config",
    value: function config() {
      return this.fetch('/api/v2/config');
    } // Returns a WebSocket connection to the messages endpoint. Asummes it
    // is reachable over TLS, when we have been loaded using it.

  }, {
    key: "messages",
    value: function messages() {
      var protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
      var host = window.location.hostname;
      var port = window.location.port ? ":".concat(window.location.port) : '';
      return new WebSocket("".concat(protocol, "://").concat(host).concat(port, "/api/v2/messages"));
    }
  }, {
    key: "tree",
    value: function tree() {
      return this.fetch('/api/v2/tree');
    } // Check if a node is present. Returns a promise that resolves to a boolean
    // indicating whether a node exists under the given URL.

  }, {
    key: "has",
    value: function has(url) {
      return this.ping("/api/v2/tree/".concat(this.nodeURL(url)));
    } // Returns node for given relative URL path.

  }, {
    key: "get",
    value: function get(url) {
      return this.fetch("/api/v2/tree/".concat(this.nodeURL(url)));
    } // Will automatically strip leading and trailing slashes from the given node
    // URL to turn it into a valid node URL for lookup.

  }, {
    key: "nodeURL",
    value: function nodeURL(url) {
      if (url.charAt(0) === '/') {
        url = url.substring(1);
      }

      if (url.charAt(url.length - 1) === '/') {
        url = url.slice(0, -1);
      }

      return url;
    } // Performs a full text search against the tree and returns the response
    // unfiltered.

  }, {
    key: "search",
    value: function search(q) {
      var params = new URLSearchParams();
      params.set('q', q);
      return this.fetch("/api/v2/search?".concat(params.toString()));
    } // Performs a narrow search against the tree. The returned nodes together
    // with `Tree.filteredBy()` can be used to create a new filtered tree view:
    //
    // ```
    // Client.filter('foo')
    //   .then((res) => {
    //      return res.nodes.map(n => n.url);
    //   })
    //   .then((urls) => {
    //      return Tree.filteredBy(urls);
    //   });
    // ```

  }, {
    key: "filter",
    value: function filter(q) {
      var params = new URLSearchParams();
      params.set('q', q);
      return this.fetch("/api/v2/filter?".concat(params.toString()));
    } // Performs HTTP GET requests, returns a promise. Fail promise when there
    // is a network issue (catch) as well as when we a HTTP response status
    // indicating an error. Using plain XHR for better browser support and easier
    // basic auth handling.

  }, {
    key: "fetch",
    value: function fetch(url) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'json';
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.responseType = type;
        xhr.addEventListener('readystatechange', function () {
          if (xhr.readyState === 4) {
            var first = xhr.status.toString().charAt(0);

            if (first !== '2' && first !== '3') {
              // The JSON error responses are formatted according to
              // JSend, and carry an error message in the `message`
              // property.
              if (type === 'json') {
                try {
                  reject(new Error("Fetching '".concat(url, "' failed :-S: ").concat(xhr.response.message)));
                } catch (e) {
                  reject(new Error("Fetching '".concat(url, "' failed :-S: ").concat(xhr.statusText)));
                }
              } else {
                reject(new Error("Fetching '".concat(url, "' failed :-S: ").concat(xhr.statusText)));
              }

              return;
            }

            resolve(xhr.response);
          }
        });
        xhr.addEventListener('error', function (ev) {
          reject(new Error("Fetching '".concat(url, "' failed :-S: ").concat(ev)));
        });
        xhr.open('GET', url);
        xhr.setRequestHeader('Accept', type === 'json' ? 'application/json' : '*/*');
        xhr.send();
      });
    } // Performs HTTP HEAD requests, returns a promise that resolves to a
    // boolean, indicating whether the resource under the given URL is existent.

  }, {
    key: "ping",
    value: function ping(url) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.addEventListener('readystatechange', function () {
          if (xhr.readyState === 4) {
            var first = xhr.status.toString().charAt(0);

            if (first !== '2' && first !== '3' && first !== '4') {
              reject(new Error("Pinging '".concat(url, "' failed :-S: ").concat(xhr.statusText)));
            } else {
              resolve(first === '2' || first === '3');
            }
          }
        });
        xhr.addEventListener('error', function (ev) {
          reject(new Error("Pinging '".concat(url, "' failed :-S: ").concat(ev)));
        });
        xhr.open('HEAD', url);
        xhr.send();
      });
    }
  }]);

  return Client;
}();

export { Client as default };